import { amountWithCurrencyCode } from 'helpers/currency';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IWagerFreeCashReceivedProps {
  amountCents: number;
  currency: string;
}

export const WagerFreeCashReceived: FC<IWagerFreeCashReceivedProps> = ({
  amountCents,
  currency,
}) => {
  const { t } = useTranslation();

  const amount = amountCents / 100;

  return (
    <p className="white-text">
      {t('common:tooltips.wagerFreeCashReceived.text', {
        amount: amountWithCurrencyCode(
          currency,
          amount,
          Number.isInteger(amount)
        ),
      })}
    </p>
  );
};
